import { axiosInstance } from '@libs/axios/axios';
import { apiCall } from '@shared/entity';
import { userApi } from '../profile/api';
import { LogData } from './entity';

export const getLogs = async (): Promise<LogData[]> =>
  apiCall(async () => await axiosInstance.get(userApi.getAllLogs()), 'api.logs.notFound');
